/**
 * Cart Pack Quantity - SEO optimized
 * Handles quantity changes for products sold in packs
 */
(function() {
  'use strict';

  document.addEventListener('click', async function(e) {
    var plus = e.target.closest('[data-pack-plus]');
    var minus = e.target.closest('[data-pack-minus]');
    if (!plus && !minus) return;

    var wrapper = e.target.closest('.cart-pack-quantity-wrapper');
    if (!wrapper) return;

    var input = wrapper.querySelector('[data-pack-input]');
    if (!input) return;

    e.preventDefault();
    e.stopPropagation();

    var packs = Math.max(1, parseInt(input.value, 10) || 1);
    var increment = parseInt(input.dataset.qtyIncrement, 10) || 1;
    var line = parseInt(input.dataset.line, 10);

    if (plus) packs++;
    if (minus) packs = Math.max(1, packs - 1);

    input.value = packs;

    var sections = [];
    document.documentElement.dispatchEvent(
      new CustomEvent('cart:grouped-sections', {
        bubbles: true,
        detail: { sections: sections }
      })
    );

    try {
      var response = await fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          line: line,
          quantity: packs * increment,
          sections: sections
        })
      });

      var cart = await response.json();

      document.dispatchEvent(
        new CustomEvent('cart:updated', {
          detail: { cart: cart }
        })
      );

      if (window.FoxTheme && window.FoxTheme.pubsub) {
        FoxTheme.pubsub.publish(
          FoxTheme.pubsub.PUB_SUB_EVENTS.cartUpdate,
          { cart: cart }
        );
      }
    } catch (err) {
      console.error('Cart pack quantity update failed:', err);
    }
  });
})();
